// @flow
import React from 'react';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import CustomButtom from '../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
    TextAlign: 'center',
    width: '70%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),

    '& button': {
      width: '90%',
    },
  },
  textSpan: {
    fontSize: '1rem',
    textAlign: 'center',
    color: colors.grey700,
  },
}));

type Props = {
  open: boolean,
  handleClose: () => void,
  typeRateSelected: string, //'STANDARD' | 'FLAT_RATE' | 'ADVANCED' | 'MANUAL',
  handleFormSubmit: (optionSave: string) => void,
  isSaving: boolean,
};

export default function ActivateShippingModal(props: Props) {
  const {
    open,
    handleClose,
    typeRateSelected,
    handleFormSubmit,
    isSaving,
  } = props;
  const classes = useStyles();

  const handleCloseModal = () => {
    handleClose();
  };

  const shipppingType = {
    STANDARD: 'Estándar',
    FLAT_RATE: 'Tarifa plana',
    ADVANCED: 'Avanzado',
    MANUAL: 'Manual',
  };

  const handleSave = () => {
    handleFormSubmit('save');
    handleCloseModal();
  };

  const handleActivateTypeRate = () => {
    handleFormSubmit('saveAndActivate');
    handleCloseModal();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography align="center" gutterBottom className={classes.title}>
          Este método de envío actualmente no está activado
        </Typography>

        <div className={classes.container}>
          <Typography className={classes.textSpan}>
            El método de envío {shipppingType[typeRateSelected]} no está activo
            actualmente.
          </Typography>
          <Typography className={classes.textSpan}>
            Por favor, seleccione una opción para continuar
          </Typography>
        </div>

        <div className={classes.actions}>
          <CustomButtom
            variant="outlined"
            color="primary"
            onClick={handleClose}
            disabled={isSaving}
          >
            Cancelar
          </CustomButtom>
          <CustomButtom
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={isSaving}
          >
            Guardar
          </CustomButtom>
          <CustomButtom
            variant="contained"
            color="primary"
            onClick={handleActivateTypeRate}
            disabled={isSaving}
          >
            Guardar y activar
          </CustomButtom>
        </div>
      </div>
    </CustomModal>
  );
}

ActivateShippingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  typeRateSelected: PropTypes.string.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
};
